"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _slicedToArray = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoiceFocusDeviceTransformer = void 0;
var voicefocus_1 = require("../../libs/voicefocus/voicefocus");
var Utils_1 = require("../utils/Utils");
var Versioning_1 = require("../versioning/Versioning");
var LoggerAdapter_1 = require("./LoggerAdapter");
var VoiceFocusTransformDevice_1 = require("./VoiceFocusTransformDevice");
var VoiceFocusTransformDeviceDelegate_1 = require("./VoiceFocusTransformDeviceDelegate");
/**
 * `VoiceFocusDeviceTransformer` is used to create {@link VoiceFocusTransformDevice|transform devices}
 * that apply Amazon Voice Focus noise suppression to audio input.
 *
 * This transformer captures relevant configuration. You should check for support, initialize,
 * and then create a device as follows:
 *
 * ```typescript
 * const deviceID = null;
 *
 * // This check for support is cheap and quick, and should be used to gate use
 * // of this feature.
 * if (!(await VoiceFocusDeviceTransformer.isSupported()) {
 *   console.log('Amazon Voice Focus not supported in this browser.');
 *   return deviceID;
 * }
 *
 * let transformer: VoiceFocusDeviceTransformer;
 * try {
 *   // This operation can fail in ways that do not indicate no support,
 *   // but do indicate an inability to apply Amazon Voice Focus. Trying again
 *   // might succeed.
 *   transformer = await VoiceFocusDeviceTransformer.create({});
 * } catch (e) {
 *   // Something went wrong.
 *   console.log('Unable to instantiate Amazon Voice Focus.');
 *   return deviceID;
 * }
 *
 * if (!transformer.isSupported()) {
 *   // The transformer will fall through, but your UI might care.
 *   console.log('Amazon Voice Focus not supported in this browser.');
 * }
 *
 * return await transformer.createTransformDevice(deviceID);
 * ```
 */
var VoiceFocusDeviceTransformer = /*#__PURE__*/function () {
  function VoiceFocusDeviceTransformer(spec, _ref, config) {
    var _ref$preload = _ref.preload,
      preload = _ref$preload === void 0 ? true : _ref$preload,
      logger = _ref.logger,
      _ref$fetchBehavior = _ref.fetchBehavior,
      fetchBehavior = _ref$fetchBehavior === void 0 ? VoiceFocusDeviceTransformer.defaultFetchBehavior() : _ref$fetchBehavior;
    _classCallCheck(this, VoiceFocusDeviceTransformer);
    this.spec = spec;
    this.supported = true;
    this.logger = logger;
    this.vfLogger = logger ? new LoggerAdapter_1.default(logger) : undefined;
    this.preload = preload;
    this.fetchBehavior = fetchBehavior;
    // If the user didn't specify one, add the default, which is
    // identified by the major and minor SDK version.
    this.spec = VoiceFocusDeviceTransformer.augmentSpec(this.spec);
    if (config) {
      this.configuration = Promise.resolve(config);
    }
  }
  /**
   * Quickly check whether Amazon Voice Focus is supported on this platform.
   *
   * This will return `false` if key technologies are absent. A value of `true` does not
   * necessarily mean that adding Amazon Voice Focus will succeed: it is still possible that the
   * configuration of the page or the CPU speed of the device are limiting factors.
   *
   * {@link VoiceFocusDeviceTransformer.create} will return an instance whose
   * `isSupported` method more accurately reflects whether Amazon Voice Focus
   * is supported in the current environment.
   *
   * This method will only reject if you provide invalid inputs.
   *
   * @param spec An optional asset group and URL paths to use when fetching. You can pass
   *             a complete {@link VoiceFocusSpec} here for convenience, matching the signature of {@link VoiceFocusDeviceTransformer.create}.
   * @param options Additional named arguments, including `logger`. Set
   *                `allowIFrame` to false to cause the support check to fail in
   *                an iframe.
   *                Chromium's security model means that audio processing works
   *                poorly in iframes.
   */
  _createClass(VoiceFocusDeviceTransformer, [{
    key: "getConfiguration",
    /**
     * Return the computed configuration for this transformer.
     */
    value: function getConfiguration() {
      return this.configuration;
    }
    /**
     * Return whether this transformer is able to function in this environment.
     * If not, calls to
     * {@link VoiceFocusDeviceTransformer.createTransformDevice|createTransformDevice}
     * will pass through an unmodified device.
     */
  }, {
    key: "isSupported",
    value: function isSupported() {
      return this.supported;
    }
    /**
     * Apply Amazon Voice Focus to the selected {@link Device}.
     *
     * If this is a stream, it should be one that does not include other noise suppression features,
     * and you should consider whether to disable automatic gain control (AGC) on the stream, because
     * it can interact with noise suppression.
     *
     * @returns a device promise. This will always resolve to either a
     *          {@link VoiceFocusTransformDevice} or undefined; it will never reject.
     */
  }, {
    key: "createTransformDevice",
    value: function createTransformDevice(device, nodeOptions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var preload, _yield$this$allocateV, _yield$this$allocateV2, vf, delegate, options;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.supported) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", undefined);
            case 2:
              _context.prev = 2;
              preload = true;
              _context.next = 6;
              return this.allocateVoiceFocus(preload);
            case 6:
              _yield$this$allocateV = _context.sent;
              _yield$this$allocateV2 = _slicedToArray(_yield$this$allocateV, 2);
              vf = _yield$this$allocateV2[0];
              delegate = _yield$this$allocateV2[1];
              options = Object.assign(Object.assign({}, nodeOptions), {
                es: this.spec.name === 'ns_es'
              });
              return _context.abrupt("return", new VoiceFocusTransformDevice_1.default(device, vf, delegate, options));
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](2);
              return _context.abrupt("return", undefined);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 14]]);
      }));
    }
  }, {
    key: "configure",
    value: function configure() {
      var preResolve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var options;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = {
                fetchBehavior: this.fetchBehavior,
                preResolve: preResolve,
                logger: this.vfLogger
              };
              return _context2.abrupt("return", voicefocus_1.VoiceFocus.configure(this.spec, options));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "init",
    value: function init() {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var config;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.configuration) {
                this.configuration = this.configure();
              }
              _context3.next = 3;
              return this.configuration;
            case 3:
              config = _context3.sent;
              if (config.supported) {
                _context3.next = 7;
                break;
              }
              // No need to init: it won't work.
              this.supported = false;
              return _context3.abrupt("return");
            case 7:
              // We initialize the first one right now, which makes it easier to detect
              // possible failures.
              // This can throw for malformed input. Pass that up the chain.
              this.pendingVoiceFocus = this.createVoiceFocus(config, this.preload);
              _context3.prev = 8;
              _context3.next = 11;
              return this.pendingVoiceFocus;
            case 11:
              _context3.next = 17;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](8);
              (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error("Unable to initialize Amazon Voice Focus: ".concat(_context3.t0));
              this.supported = false;
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[8, 13]]);
      }));
    }
  }, {
    key: "createVoiceFocus",
    value: function createVoiceFocus(config, preload) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var delegate, vf;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              delegate = new VoiceFocusTransformDeviceDelegate_1.default();
              _context4.next = 3;
              return voicefocus_1.VoiceFocus.init(config, {
                delegate: delegate,
                preload: preload,
                logger: this.vfLogger
              });
            case 3:
              vf = _context4.sent;
              return _context4.abrupt("return", [vf, delegate]);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "allocateVoiceFocus",
    value: function allocateVoiceFocus(preload) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var vf;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.supported) {
                _context5.next = 2;
                break;
              }
              throw new Error('Not supported.');
            case 2:
              if (!this.pendingVoiceFocus) {
                _context5.next = 6;
                break;
              }
              // Use the one we already have, and free the slot for any future execution.
              vf = this.pendingVoiceFocus;
              this.pendingVoiceFocus = undefined;
              return _context5.abrupt("return", vf);
            case 6:
              _context5.t0 = this;
              _context5.next = 9;
              return this.configuration;
            case 9:
              _context5.t1 = _context5.sent;
              _context5.t2 = preload;
              return _context5.abrupt("return", _context5.t0.createVoiceFocus.call(_context5.t0, _context5.t1, _context5.t2));
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }], [{
    key: "isSupported",
    value: function isSupported(spec, options) {
      var _a, _b;
      var fetchBehavior = VoiceFocusDeviceTransformer.defaultFetchBehavior();
      var logger = (options === null || options === void 0 ? void 0 : options.logger) ? new LoggerAdapter_1.default(options.logger) : undefined;
      var opts = {
        fetchBehavior: fetchBehavior,
        logger: logger
      };
      // This is impossible to test in Node, so Istanbul ignore.
      /* istanbul ignore next */
      if (Utils_1.isIFramed()) {
        if ((options === null || options === void 0 ? void 0 : options.allowIFrame) === false) {
          (_a = options === null || options === void 0 ? void 0 : options.logger) === null || _a === void 0 ? void 0 : _a.error('Amazon Voice Focus support check inside iframe: not supported.');
          return Promise.resolve(false);
        } else {
          (_b = options === null || options === void 0 ? void 0 : options.logger) === null || _b === void 0 ? void 0 : _b.warn('Amazon Voice Focus support check inside iframe: not recommended.');
        }
      }
      return voicefocus_1.VoiceFocus.isSupported(VoiceFocusDeviceTransformer.augmentSpec(spec), opts);
    }
    /**
     * Create a transformer that can apply Amazon Voice Focus noise suppression to a device.
     *
     * This method will reject if the provided spec is invalid, or if the process of
     * checking for support or estimating fails (e.g., because the network is unreachable).
     *
     * If Amazon Voice Focus is not supported on this device, this call will not reject and
     * `isSupported` will return `false` on the returned instance. That instance will
     * pass through devices unmodified.
     *
     * @param spec A definition of how you want Amazon Voice Focus to behave. See the declaration of
     *             {@link VoiceFocusSpec} for details.
     * @param options Additional named arguments, including `logger` and `preload`.
     */
  }, {
    key: "create",
    value: function create() {
      var spec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 ? arguments[2] : undefined;
      var
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      createMeetingResponse = arguments.length > 3 ? arguments[3] : undefined;
      var
      // eslint-disable-next-line
      createAttendeeResponse = arguments.length > 4 ? arguments[4] : undefined;
      var _a, _b, _c;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var meetingFeaturesAllowsES, forbiddenConfig, forbiddenSpec, transformer;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (createMeetingResponse) {
                if (createMeetingResponse.Meeting.Meeting) {
                  createMeetingResponse = createMeetingResponse.Meeting;
                }
              }
              meetingFeaturesAllowsES = ((_c = (_b = (_a = createMeetingResponse === null || createMeetingResponse === void 0 ? void 0 : createMeetingResponse.Meeting) === null || _a === void 0 ? void 0 : _a.MeetingFeatures) === null || _b === void 0 ? void 0 : _b.Audio) === null || _c === void 0 ? void 0 : _c.EchoReduction) === 'AVAILABLE';
              forbiddenConfig = config && config.supported === true && config.model.name === 'ns_es' && !meetingFeaturesAllowsES;
              forbiddenSpec = spec.name === 'ns_es' && !meetingFeaturesAllowsES;
              if (!(forbiddenConfig || forbiddenSpec)) {
                _context6.next = 6;
                break;
              }
              throw new Error('Echo Reduction requested but not enabled.');
            case 6:
              transformer = new VoiceFocusDeviceTransformer(spec, options, config); // This also preps the first `VoiceFocus` instance.
              _context6.next = 9;
              return transformer.init();
            case 9:
              return _context6.abrupt("return", transformer);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
    }
    /**
     * Given a spec and options, perform the configuration work that is
     * ordinarily performed during creation of a transformer.
     *
     * The computed configuration is not portable between devices or sessions,
     * but is useful for 'moving' transformers between windows.
     *
     * Pass the returned configuration as the third argument to a call to
     * {@link VoiceFocusDeviceTransformer.create} with the matching spec.
     */
  }, {
    key: "configure",
    value: function configure() {
      var spec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var transformer;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              transformer = new VoiceFocusDeviceTransformer(spec, options, undefined);
              return _context7.abrupt("return", transformer.configure(true));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
    }
  }, {
    key: "augmentSpec",
    value: function augmentSpec(spec) {
      if (!spec || !spec.assetGroup && !spec.revisionID) {
        return Object.assign(Object.assign({}, spec), {
          assetGroup: VoiceFocusDeviceTransformer.currentSDKAssetGroup()
        });
      }
      return spec;
    }
  }, {
    key: "majorVersion",
    value: function majorVersion() {
      return Versioning_1.default.sdkVersion.match(/^[1-9][0-9]*\.(?:0|[1-9][0-9]*)/)[0];
    }
  }, {
    key: "majorMinorVersion",
    value: function majorMinorVersion() {
      return Versioning_1.default.sdkVersion.match(/^[1-9][0-9]*\.(?:0|(?:[1-9][0-9]*))\.(?:0|[1-9][0-9]*)/)[0];
    }
  }, {
    key: "currentSDKAssetGroup",
    value: function currentSDKAssetGroup() {
      // Just on the off chance someone does something silly, handle
      // malformed version strings here.
      var v = this.majorVersion();
      // Just a little safety.
      /* istanbul ignore next */
      if (!v) {
        return "stable-v1";
      }
      return "sdk-".concat(v);
    } // Note that we use query strings here, not headers, in order to make these requests 'simple' and
    // avoid the need for CORS preflights.
    // Be very, very careful if you choose to add headers here. You should never need to.
  }, {
    key: "defaultFetchBehavior",
    value: function defaultFetchBehavior() {
      // Just a little safety.
      /* istanbul ignore next */
      var version = VoiceFocusDeviceTransformer.majorMinorVersion() || 'unknown';
      var ua = Versioning_1.default.sdkUserAgentLowResolution;
      return {
        escapedQueryString: "sdk=".concat(encodeURIComponent(version), "&ua=").concat(encodeURIComponent(ua))
      };
    }
  }]);
  return VoiceFocusDeviceTransformer;
}();
exports.VoiceFocusDeviceTransformer = VoiceFocusDeviceTransformer;
exports.default = VoiceFocusDeviceTransformer;